"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function findSectionValue(card, sectionType) {
  var _section$components$;

  var section = card.displayable_dynamic_sections.find(function (s) {
    return s.type === sectionType;
  });
  return section === null || section === void 0 ? void 0 : (_section$components$ = section.components[0]) === null || _section$components$ === void 0 ? void 0 : _section$components$.value;
}

function cardDisplayName(card) {
  var _findSectionValue;

  return (_findSectionValue = findSectionValue(card, 'title')) !== null && _findSectionValue !== void 0 ? _findSectionValue : card.value;
}

var DynamicCardComponent = function DynamicCardComponent(_ref) {
  var component = _ref.component,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect;
  return (0, _preact.h)("div", {
    className: "forethought-agent__cards"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__cards-message",
    dangerouslySetInnerHTML: {
      __html: component.message
    }
  }), (0, _preact.h)("div", {
    className: "forethought-agent__cards-grid"
  }, component.cards.map(function (card) {
    var title = cardDisplayName(card);
    var image = findSectionValue(card, 'image');
    var details = card.displayable_dynamic_sections.filter(function (s) {
      return s.type === 'content';
    }).flatMap(function (s) {
      return s.components;
    }).filter(function (c) {
      return c.value;
    });
    return (0, _preact.h)("button", {
      key: card.value,
      type: "button",
      className: "forethought-agent__card",
      disabled: disabled,
      onClick: function onClick() {
        return onSelect(component.output_variable, card.value, title);
      }
    }, image && (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(image),
      alt: title,
      className: "forethought-agent__card-image"
    }), (0, _preact.h)("div", {
      className: "forethought-agent__card-title"
    }, title), details.length > 0 && (0, _preact.h)("ul", {
      className: "forethought-agent__card-details"
    }, details.map(function (d, i) {
      return (0, _preact.h)("li", {
        key: i
      }, d.label && (0, _preact.h)("strong", null, d.label, ": "), d.value);
    })));
  })));
};

var _default = DynamicCardComponent;
exports.default = _default;